import {useNavigation} from '@react-navigation/native';
import React, {useState} from 'react';
import {
  Alert,
  Image,
  ImageBackground,
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import ButtonComponent from '../../../components/ButtonComponent/ButtonComponent';
import Input from '../../../components/Input/Input';
import {Images} from '../../../constants/Images';
import {styles} from './styles';
import FontAwesome6 from 'react-native-vector-icons/FontAwesome6';
import {Colors} from '../../../constants/Colors';
import {useRegisterFinishStore} from '../../../store/RegisterStore';
import AuthService from '../../../services/AuthService/AuthService';
import {NavigationProps} from '../../../navigation/Routes';
import {AppRoutes} from '../../../navigation/Routes.types';
import {useLoadingStore} from '../../../store/LoadingStore';
import { showSuccess } from '../../../utils/globalAlert';

const ResendToken = () => {
  const {registerFinishData} = useRegisterFinishStore();

  const {navigate, goBack} = useNavigation<NavigationProps>();

  const {hideLoading, showLoading} = useLoadingStore();

  const [document, setDocument] = useState<string>('');

  const handleResendToken = async () => {
    if (document) {
      showLoading();
      try {
        await AuthService.resendTokenPost(document, 'email');
        showSuccess('Conecta Brasal', 'Token reenviado! Confira seus canais de contato.');
        navigate(AppRoutes.TOKEN_SCREEN);
      } catch (error) {
        console.error(error);
        Alert.alert('Opss...', 'Algo deu errado. Tente novamente.');
      } finally {
        hideLoading();
      }
    } else {
      Alert.alert('Informe seu CNPJ/CPF para prosseguir');
    }
  };

  return (
    <ImageBackground
      // source={Images.backgroundCoke}
      style={styles.imageBackground}>
       <KeyboardAvoidingView
              behavior={Platform.OS === 'ios' ? 'position' : 'height'}
              style={styles.container}>
        <ScrollView showsVerticalScrollIndicator={false}>
          <View style={styles.containerArrow}>
            <TouchableOpacity onPress={goBack} style={styles.arrowButton}>
              <FontAwesome6
                name="arrow-left"
                color={Colors.GrayPallete.lightgrayThree}
                size={22}
              />
            </TouchableOpacity>
            <Image source={Images.ProfileSimbol} style={styles.simbol} />
          </View>
          <Text style={styles.title}>
            Reenviar Token de Validação
          </Text>
          <Text style={styles.description}>
            Digite seu CNPJ/CPF para receber um novo token de validação.
          </Text>
          <Input
            title="CNPJ/CPF"
            placeholder="CNPJ/CPF"
            mt={40}
            onChangeText={text => setDocument(text)}
          />
          <View style={styles.containerButton}>
            <ButtonComponent
              title="Reenviar Token de Validação"
              onPress={handleResendToken}
            />
          </View>
          <View style={styles.containerText}>
            <Text style={styles.valid}>Já validou seu cadastro?</Text>
            <TouchableOpacity onPress={goBack}>
              <Text style={styles.goBack}>Volte ao login.</Text>
            </TouchableOpacity>
          </View>
        </ScrollView>
      </KeyboardAvoidingView>
    </ImageBackground>
  );
};

export default ResendToken;
